enum VAN_IMAGE_TYPES {
  qr_code = 'qr_code',
}

export { VAN_IMAGE_TYPES }
